
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle'
import './assets/css/style.css'


import { Routes, Route ,Link} from 'react-router-dom';
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import Register from './pages/Auth/Register';
import StudentLayout from './layouts/student'
import ResetPassowrdPage from './pages/Auth/ResetPassword';
import { useEffect } from 'react';

function App() {
  useEffect(() => {
    <script>{
              (function(c,l,a,r,i,t,y){
                c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
                t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
                y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
              })(window, document, "clarity", "script", "qxql9x9ovm")
              }
            
            </script>
  },[])
// console.log('testing')
  return (
    <div className="App">
      <Routes>
        <Route path='/' element={<Login/>}/>
        <Route exact path='/login' element={<Login/>}/>
        <Route exact path='/forgot-password' element={<ForgotPassword/>}/>
        <Route exact path='/reset-password/:resetCode' element={<ResetPassowrdPage/>}/>
        <Route exact path='/register' element={<Register/>}/>
        <Route exact path='student/*' element={<StudentLayout/>}/>
        <Route path='*' element={
          <div className='page_not_found'>
          <h1 className='text-center'>404</h1>
          <p>Page not found</p>
          <Link to={'login'} className='btn btn-primary'>Back to Home</Link>
          </div>
        }/>
      </Routes>
    </div>

  );
}

export default App;
